import React, { useState, useEffect } from 'react'
import { Text, Warning } from "../../formitems/Index";
import { LeftOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { Client, Fleets, Ranks, Airports, Manager } from '../../../Queries/User/User'
import { Checkbox } from 'antd';
import { useQuery } from "@apollo/client";
import DatePicker from "react-datepicker";
import moment from 'moment';
import firebase from 'firebase'
import dateFormat from 'dateformat'
import { storage } from "../../../Firebase/firebase";
import { Link } from 'react-router-dom'
import crypto from 'crypto'
const AddNewUser = ({ dataaAdminn, email, setEmail, exist, addUserSimulator, addUserManager, addUserGround, addUserAircraft, closeForm, addUserCrew, addUserOptimiser, adduserInregister, userAddUsertable }) => {
    const [aircraft, setAircraft] = useState(false)
    const [crew, setCrew] = useState(false)
    const [ground, setGround] = useState(false)
    const [simulator, setsimulator] = useState(false)
    const [managerr, setmanagerr] = useState(false)
    const [optimiser, setoptimiser] = useState(false)
    const [dataAdmin, setdataAdmin] = useState(false)
    const [Active, setActive] = useState(false)
    const [dropdown2, setdropdown2] = useState('')
    const [fleet, setFleet] = useState('')
    const [emplyeeCode, setEmplyeeCode] = useState('')
    const [Rank, setRank] = useState('')
    const [name, setname] = useState('')
    const [licenceNumber, setLicenceNumber] = useState('')
    const [phone1, setPhone1] = useState('')
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState("");
    const [url, setUrl] = useState("");
    const [managers, setmanagers] = useState('')
    const [phone2, setPhone2] = useState('')
    const [airport, setAirport] = useState('')
    const [Blur, setBlur] = useState(false)
    const [personalEmailId, setpersonalEmailId] = useState('')
    const [permanentAddress, setPermanentAddress] = useState('')
    const [tempraryAddress, setTempraryAddress] = useState('')
    const id = crypto.randomBytes(16).toString("hex");
    const defaultDate = new Date('2000/1/1')
    const [Issuedates, setIssuedates] = useState('')
    const time = moment(Issuedates).format("YYYY/MM/DD");
    const issueDate = new Date(time)
    const [joiningDate, setJoiningDate] = useState('')
    const joinDate = moment(joiningDate).format("YYYY/MM/DD");
    const newJoiningdate = new Date(joinDate)
    const newdate = new Date()
    const news = moment(newdate).format("YYYY/MM/DD");
    const { data: clients } = useQuery(Client)
    const { data: fleets } = useQuery(Fleets, {
        variables: { id: dropdown2[1] }
    })
    const { data: ranks } = useQuery(Ranks, {
        variables: { id: dropdown2[1] }
    })
    const { data: airports } = useQuery(Airports)
    const { data: manager } = useQuery(Manager, {
        variables: { id: dropdown2[1] }
    })
    const Option = Select.Option;
    if (Issuedates > '1950/1/1' && Issuedates < '2002/1/1') {
        var birthdate = Issuedates
    }
    const handChange = e => {
        const file = e.target.files[0];
        if (file) {
            // const fileType = file["type"];
            const fileType = file;
            if (fileType) {
                setError("");
                setImage(file);
                setUrl("")
            } else {
                setError("Please select an image to upload");
            }
        }
    };
    const handleUpdate = () => {
        if (image) {
            const uploadTask = storage.ref(`${dropdown2[0]}/profile pictures/${email}`).put(image);
            uploadTask.on(
                "state_changed",
                snapshot => {
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    setProgress(progress);
                },
                error => {
                    setError(error);
                },
                () => {
                    storage
                        .ref(`${dropdown2[0]}/profile pictures/`)
                        .child(`${email}`)
                        .getDownloadURL()
                        .then(url => {
                            setUrl(url);
                            setProgress(0);
                        });
                }
            );
        } else {
            setError("Error please choose an image to upload");
        }
    };
    function onChangeManager(e, v) {
        if (v === 'active') {
            setActive(e.target.checked)
        } else if (v === 'Crew') {
            setCrew(e.target.checked)
        } else if (v === 'Ground') {
            setGround(e.target.checked)
        } else if (v === 'Simulator') {
            setsimulator(e.target.checked)
        } else if (v === 'Aircraft') {
            setAircraft(e.target.checked)
        } else if (v === 'Manager') {
            setmanagerr(e.target.checked)
        } else if (v === 'Optimiser') {
            setoptimiser(e.target.checked)
        } else if (v === 'DataAdmin') {
            setdataAdmin(e.target.checked)

        }
    }

    const AddUserMuatation = () => {
        const registerUser = async e => {
            let createNewUser = firebase.functions().httpsCallable('adminCreateUser');
            let clientInput = dropdown2[0]
            let { clientid, clientname } = await firebase.firestore().collection('clients').where("clientname", "==", clientInput).get()
                .then(fetchClient => {
                    let updatedClient = fetchClient.docs[0].data()
                    return {
                        clientid: updatedClient.clientsid,
                        clientname: updatedClient.clientname
                    }
                })
                .catch(err => {
                    throw err
                })

            let data = {
                email: email,
                clientid: dropdown2[1],
                clientname: dropdown2[0],
                birthdate: birthdate ? birthdate : '1950/1/1',
                ecode: emplyeeCode,
                emailofficial: email,
                emailpersonal: personalEmailId,
                fleetsid: fleet,
                icao: airport[0],
                joindate: joinDate ? joinDate : news ,
                licence: licenceNumber,
                managersid: managers[0],
                department: dropdown2[2],
                name: name,
                phone1: phone1,
                phone2: phone2,
                managername: managers[1],
                photo: url,
                pmtaddress: permanentAddress,
                ranksid: Rank,
                tempaddress: tempraryAddress,
                _optimiser: optimiser,
                _simulator: simulator,
                _aircraft: aircraft,
                _crew: crew,
                _dataadmin: dataAdmin,
                _ground: ground,
                _manager: managerr,
                active: Active,
                addresspmt: permanentAddress,
                addresstemp: tempraryAddress,
                adminactive: dataAdmin,
                adminapproved: true,
                airactive: aircraft,
                aircraft: aircraft,
                approved: true,
                base: airport[0],
                clientsid: dropdown2[1],
                crew: crew,
                crewactive: crew,
                dataadmin: dataAdmin,
                ground: ground,
                groundactive: ground,
                joiningdate: joinDate ? joinDate: news,
                license: licenceNumber,
                manageactive: managerr,
                managed: false,
                manager: managerr,
                optimactive: optimiser,
                optimiser: optimiser,
                pending: false,
                rankid: Rank,
                regactive: true,
                roleallotted: true,
                simactive: simulator,
                simulator: simulator,
                useractive: Active,
            }

            createNewUser({ user: data })
                .then(() => {
                    console.log("User creation Successfull!!");
                })
                .catch(err => {
                    console.log(`Error Occured!! ${err}`);
                })
            return null
        }
        registerUser()
    }
    const blur = () => {
        setBlur(true)
    }
    return (
        <div>
            <div className="category-title">
                <span className="client-back" onClick={() => closeForm()}>
                    {<LeftOutlined />} USER
            </span>
            Add New User
          </div>
            <div className="toggle-form-container">
                <p>Email</p>
                {Blur === true ? <Text disabled placeholder="Enter Email" value={email} onChange={e => setEmail(e.target.value)} /> : <Text onBlur={blur} placeholder="Enter Email" value={email} onChange={e => setEmail(e.target.value)} />}
                {exist?.aatmsv4_users.length !== 1 ? (
                    <div>
                        {email !== "" ? (
                            <div>
                                <p>Client</p>
                                {dropdown2 !== '' ? <Text disabled placeholder="Enter client" value={dropdown2[0]} onChange={e => setEmail(e.target.value)} /> : (
                                    <Select value={dropdown2 ? dropdown2 : "Select Client"} onChange={e => setdropdown2(e)}>
                                        {clients?.aatmsv4_clients?.map((el, i) => (
                                            <Option key={i} value={[el.clientname, el.clientsid, el.department]}>{el.clientname}</Option>
                                        ))}
                                    </Select>
                                )}
                                {dropdown2 !== "" ? (
                                    <div>
                                        <p>Fleets</p>
                                        <Select value={fleet ? fleet : "Select Fleet"} onChange={e => setFleet(e)}>
                                            {fleets?.aatmsv4_fleets?.map((el, i) => (
                                                <Option key={i} value={el?.fleetsid}>{el?.aircraft}</Option>
                                            ))}
                                        </Select>
                                    </div>
                                ) : null}
                                {dropdown2 !== "" ? (
                                    <div>
                                        <p>Ranks</p>
                                        <Select value={Rank ? Rank : "Select Rank"} onChange={e => setRank(e)}>
                                            {ranks?.aatmsv4_ranks?.map((el, i) => (
                                                <Option key={i} value={el?.ranksid}>{el.rank}</Option>
                                            ))}
                                        </Select>
                                    </div>
                                ) : null}
                                <p>Employee Code</p>
                                <Text placeholder="Enter Employee Code" value={emplyeeCode} onChange={e => setEmplyeeCode(e.target.value)} />
                                <p>Name</p>
                                <Text placeholder="Enter Name" value={name} onChange={e => setname(e.target.value)} />
                                <p>Airports</p>
                                <Select value={airport ? airport[1] : "Select Base"} onChange={e => setAirport(e)}>
                                    {airports?.aatmsv4_airports?.map((el, i) => (
                                        <Option key={i} value={[el?.icao, el.airport]}>{el.icao} : {el.airport}</Option>
                                    ))}
                                </Select>
                                <p>Phone:1</p>
                                <Text placeholder="Enter Phone:1 Number" value={phone1} onChange={e => setPhone1(e.target.value)} />
                                <p>Phone:2</p>
                                <Text placeholder="Enter Phone:2 Number" value={phone2} onChange={e => setPhone2(e.target.value)} />
                                <p>Personal Email-ID</p>
                                <Text placeholder="Enter Personal Email ID" value={personalEmailId} onChange={e => setpersonalEmailId(e.target.value)} />
                                <p>Date of Birth<span style={{ color: 'orange' }}> Date should be &gt; 1/1/1950 &amp; &lt; 1/1/2002</span></p>
                                <DatePicker selected={Issuedates !== '' && Issuedates > '1950/1/1' && Issuedates < '2002/1/1' ? issueDate : defaultDate} onChange={date => setIssuedates(dateFormat(date, "isoDate"))} />
                                <br />
                                <br />
                                <p>Joining Date</p>
                                <DatePicker selected={joiningDate !== '' ? newJoiningdate : new Date()} onChange={date => setJoiningDate(dateFormat(date, "isoDate"))} />
                                <br />
                                <br />
                                <p>Licence Number</p>
                                <Text placeholder="Enter Licence Number" value={licenceNumber} onChange={e => setLicenceNumber(e.target.value)} />
                                <p>Permanent Address</p>
                                <Text placeholder="Enter Licence Number" value={permanentAddress} onChange={e => setPermanentAddress(e.target.value)} />
                                <p>Temprary Address</p>
                                <Text placeholder="Enter Licence Number" value={tempraryAddress} onChange={e => setTempraryAddress(e.target.value)} />
                                {dropdown2 !== "" ? (
                                    <div>
                                        <p>Responsible Managers</p>
                                        <Select value={managers ? managers[1] : "Select Responsible Manager"} onChange={e => setmanagers(e)}>
                                            {manager?.aatmsv4_managers?.map((el, i) => (
                                                <Option key={i} value={[el?.managersid, el?.managername]}>{el?.managername}</Option>
                                            ))}
                                        </Select>
                                    </div>
                                ) : null}
                                <input type="file" style={{ backgroundColor: 'beige', borderRadius: '25px' }} onChange={handChange} /><br />
                                {!url ? <button className="submit-button" onClick={() => handleUpdate()}>Save</button> : null}
                                <br />
                                {url !== "" ? (
                                    <div>
                                        <div style={{ width: '100', display: 'flex', justifyContent: 'space-around' }}>
                                            <Checkbox className="userAuth" defaultChecked={Active} onChange={(e) => onChangeManager(e, 'active')}>Active</Checkbox>
                                            <Checkbox className="userAuth" defaultChecked={crew} onChange={(e) => onChangeManager(e, 'Crew')}>Crew</Checkbox>
                                            <Checkbox className="userAuth" defaultChecked={ground} onChange={(e) => onChangeManager(e, 'Ground')}>Ground</Checkbox>
                                            <Checkbox className="userAuth" defaultChecked={simulator} onChange={(e) => onChangeManager(e, 'Simulator')}>Simulator</Checkbox>
                                        </div>
                                        <br />
                                        <br />
                                        <div style={{ width: '100', display: 'flex', justifyContent: 'space-around' }}>
                                            <Checkbox className="userAuth" defaultChecked={aircraft} onChange={(e) => onChangeManager(e, 'Aircraft')}>Aircraft</Checkbox>
                                            <Checkbox className="userAuth" defaultChecked={managerr} onChange={(e) => onChangeManager(e, 'Manager')}>Manager</Checkbox>
                                            <Checkbox className="userAuth" defaultChecked={optimiser} onChange={(e) => onChangeManager(e, 'Optimiser')}>Optimiser</Checkbox>
                                            <Checkbox className="userAuth" defaultChecked={dataAdmin} onChange={(e) => onChangeManager(e, 'DataAdmin')}>DataAdmin</Checkbox>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                ) : (
                        <div>
                            <Warning title="User already exists !!! Duplicate entry is prohibited ! " />
                        </div>
                    )}
            </div>
            {email !== "" && exist?.aatmsv4_users.length !== 1 && url !== "" && issueDate !=='' && joinDate !== '' ? (
                <div>
                    <Link to="/dashboard/data-admin">
                        <button onClick={() => {
                            AddUserMuatation()
                        }} className="submit-button">
                            Add User
              </button>
                    </Link>
                    <button onClick={() => closeForm()} className="cancel-button">
                        Cancel
                </button>
                </div>
            ) : null}
        </div>
    )
}

export default AddNewUser
